<template>
    <div @click="onClose" id="modal_wrap">
        <div class="modal_container">
            <div class="swal2-header">
                <ul class="swal2-progress-steps" style="display: none;"></ul>
                <div class="swal2-icon swal2-error" style="display: none;">
                    <span class="swal2-x-mark"><span class="swal2-x-mark-line-left"></span><span
                            class="swal2-x-mark-line-right"></span></span>
                </div>
                <div class="swal2-icon swal2-question" style="display: none;"></div>
                <div class="swal2-icon swal2-warning" style="display: none;"></div>
                <div class="swal2-icon swal2-info swal2-animate-info-icon" style="display: flex;"></div>
                <div class="swal2-icon swal2-success" style="display: none;">
                    <div class="swal2-success-circular-line-left" style="background-color: rgb(255, 255, 255);"></div>
                    <span class="swal2-success-line-tip"></span> <span class="swal2-success-line-long"></span>
                    <div class="swal2-success-ring"></div>
                    <div class="swal2-success-fix" style="background-color: rgb(255, 255, 255);"></div>
                    <div class="swal2-success-circular-line-right" style="background-color: rgb(255, 255, 255);"></div>
                </div>
            </div>
            <div class="modal_header">
                <h2>Заявка <strong>{{modalData.id}}</strong></h2>
            </div>
            <div class="modal_body">
                <div class="text-left">
                    <template v-if="modalData.comment && modalData.comment.length">
                    <table class="table table-sm table-hover">
                        <thead>
                        <tr>
                            <th width="50"></th>
                            <th>Комментарий</th>
                            <th width="200">Дата</th>
                        </tr>
                        </thead>
                        <tbody>
                            <tr v-for="(comment, index) in modalData.comment">
                                <td>{{index+1}}</td>
                                <td>{{comment.text}}</td>
                                <td>
                                    {{comment.user_name}}<br>
                                    {{comment.created_at}}
                                </td>
                            </tr>
                        </tbody>
                    </table>
                    </template>
                    <template v-else>
                        <h3>Комментариев нет</h3>
                    </template>
                </div>
                <form action="" @submit.prevent="saveComment" ref="commentForm">
                    <input type="text" required v-model="newComment" class="form-control" placeholder="Ваш комментарий">
                    <div v-if="errorMessage" class="error_messages p-t-10" v-html="errorMessage"></div>

                <div class="modal_actions">
                    <vue-ladda button-class="btn btn-success"
                               data-style="zoom-in"
                               type="submit"
                               :loading="acceptBtnLoading">Сохранить
                    </vue-ladda>
                    <button @click="onClose" id="closeBtn" class="btn btn-default">Отмена</button>
                </div>
                </form>
            </div>
            <div class="modal_footer"></div>
        </div>
    </div>
</template>

<script>
    import VueLadda from 'vue-ladda/src/vue-ladda.vue'
    import api from '@/api'

    export default {
        components: {
            VueLadda,
        },
        data() {
            return {
                acceptBtnLoading: false,
                errorMessage: null,
                newComment: null,
            }
        },
        props: [
            'onModalClose', 'onModalAccept', 'modalData', 'updateOrder'
        ],
        methods: {
            async saveComment() {
                console.log('save');
                this.acceptBtnLoading = true;

                let {data} = await api.post('/orders/updateOrderByField', {
                    orderId: this.modalData.id,
                    fields: {
                        comment: this.newComment,
                    }
                });

                if (data.success){
                    this.newComment = null;
                    if (!this.modalData.comment) this.modalData.comment = [];
                    this.modalData.comment.push(data.savedData);
                    this.updateOrder(this.modalData);
                    this.onModalClose('comment');
                }else{
                    toastr['warning']('Ошибка!');
                }

                this.acceptBtnLoading = false;
            },
            onAccept() {
                this.saveComment();
                // this.saveComment();
            },
            onReject(e) {
                this.onModalClose();
            },
            onClose(e) {
                if (e.target && (e.target.id === 'modal_wrap' || e.target.id === 'closeBtn') && !this.acceptBtnLoading) {
                    this.onModalClose('comment');
                }
            }
        }
    }

</script>

<style scoped>
    .modal_container{
        max-width: 75%;
    }
    .error_messages {
        color: red;
    }

    .btn {
        margin: 10px;
        padding: 7px 25px;
        font-size: 24px;
    }

    #modal_wrap {
        display: none;
        position: fixed;
        z-index: 99999;
        background-color: rgba(0, 0, 0, 0.55);
        width: 100vw;
        height: 100vh;
        top: 0;
        left: 0;
        display: flex;
        justify-content: center;
        align-items: center;
    }

    .modal_body {
        z-index: 1;
        justify-content: center;
        margin: 0;
        padding: 0;
        color: #545454;
        font-size: 1.125em;
        font-weight: 400;
        line-height: normal;
        text-align: center;
        word-wrap: break-word;
    }

    .modal_header {
        position: relative;
        max-width: 100%;
        margin: 0 0 .4em;
        padding: 0;
        color: #595959;
        font-size: 1.875em;
        font-weight: 600;
        text-align: center;
        text-transform: none;
        word-wrap: break-word;
    }

    .modal_actions {
        display: flex;
        z-index: 1;
        flex-wrap: wrap;
        align-items: center;
        justify-content: center;
        width: 100%;
        margin: 1.25em auto 0;
    }

    .modal_container {
        background-color: white;
        padding: 20px;
        min-width: 500px;
        width: fit-content;
    }
</style>
